/**
 * This function takes a optional param to return it
 * @param {string=} param this is param
 */

const getUserData = () => {
  const saved = localStorage.getItem("userData");
  const initialValue = JSON.parse(saved);
  return (
    initialValue || {
      token: "",
      email: "",
      nome: "",
      permissoes: "",
      expirationDate: "",
      entidade_ativa: "",
      entidades: [],
    }
  );
}

const tokenValidation = (param) => {
  return getUserData().token ? true : false
};

export { tokenValidation };
